import { Injectable } from '@angular/core';
import { DataShareService } from './data-share.service';
import { PolicyConstant } from '../_constants/policyConstants';

@Injectable({
  providedIn: 'root',
})
export class CheckAuthorizationService {

  constructor(private dataShareService: DataShareService) { }
  PolicyConstant1:any=PolicyConstant;
  checkAuthorization(requiredPolicyData:any) {
    return new Promise(async (resolve, reject) => {
      try {
        const userPolicyList: any = await this.dataShareService.getPolicyList();
        const userPolicy = userPolicyList.find((obj:any) => {
          return obj['moduleName'] === requiredPolicyData.moduleName;
        });
        if (userPolicy) {
          const requiredPermission = this.PolicyConstant1[requiredPolicyData.policy];
          const availablePermission = this.PolicyConstant1[userPolicy.policy];
          if (availablePermission >= requiredPermission) {
            resolve(true);
          }
        }
        resolve(false);
      } catch (err) {
        reject(err);
      }
    });
  }

  getPolicyName(moduleName:any) {
    var userPolicyList = this.dataShareService.userPolicyList;
    if(userPolicyList.length==0)
    {
      var StorageData=localStorage.getItem('userPolicyList1');
      userPolicyList = JSON.parse(StorageData?StorageData:"{}");
    }
    const moduleData:any = userPolicyList.find(obj => {
      return obj['moduleName'] === moduleName;
    });
    if (moduleData) {
      return moduleData.policy;
    }
  }
}
